import React, { Component } from 'react';
import { Input } from '@vds/inputs';
import '../Zipcode/Zipcode.css';
import {  scrollInView } from '../../../utils/common';
import debounce from 'lodash/debounce';

class Zipcode extends Component {

    constructor(props) {
        super(props);
        this.state = {
            outSideClick: false,
            invalidZipCode: false
        };
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.debouncedFn =  debounce((input) => {
            this.props.postUIEventLog({eventType: 'log', eventName: "Zipcode Change", sectionName: "LQ", log: input});
        }, 1000);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        //const inputDiv = document.getElementsByClassName('Zip-Code-Input-field')[0];
        /*if(inputDiv) {
            inputDiv.focus();
            window.setTimeout(() => {inputDiv.focus()}, 1500);
        }*/
        if(this.zipcodeRef) {
            const input = this.zipcodeRef.getElementsByTagName("input")[0];
            setTimeout(() => {input.focus();}, 1000 );
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    /**
     * Set the wrapper ref
     */
    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    /**
     * Alert if clicked on outside of element
     */
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({ outSideClick: true })
        }
    }
    handleSubmit = (e) => {
        e.preventDefault()
    }
    // Checking for the entered zip code in availab suggestions list before fetching the new suggestions
    getZipcodes = (e) => {
        let userInput = e.target.value;
        e.persist();
        if(userInput) {
            userInput = userInput?.trim();
            if (userInput?.length < 5) {
                this.setState({invalidZipCode: true});
             } else{
                this.setState({invalidZipCode: false});
             }
        }
        this.setState({ outSideClick: false });
        if (/^[0-9]{0,5}$/.test(userInput))
            this.props.getZipcodes(userInput);

            const zipcodeSuggestionList = this.props.zipcodeSuggestionList;

            if(zipcodeSuggestionList){
                       Object.keys(zipcodeSuggestionList).map((key) => {
                                 const selectedZipcode = zipcodeSuggestionList[key];
                                     
                                    if(selectedZipcode.zip === userInput) {  
                                        this.props.selectThisZipcode(selectedZipcode);      
                                        this.setState({ outSideClick: true });
                                    }
                                

                        })         
            }

            this.debouncedFn(userInput);
    }

    selectThisZipcode = (selectedZipcode) => {
        this.setState({invalidZipCode: false});
        this.props.selectThisZipcode(selectedZipcode);
    }

    // selectedCityAndState() {

    //     const selectedZipcode = this.props.selectedZipcode ? this.props.selectedZipcode : "";

    //     if (selectedZipcode.length === 0) {
    //         return null;
    //     }

    //     const cityAndState = selectedZipcode.city + ", " + selectedZipcode.state;

    //     return (
    //         <div className="city-input-box">
    //             <Input locked="false" label="City" width="100%" value={selectedZipcode.altCity || ""} name="city-box" />
    //         </div>
    //     );
    // }


    render() {       
        console.log("peops-----",this.props.zipcodeEnteredByUser)
        const zipcodeSuggestionList = this.props.zipcodeSuggestionList;
        const zipcodeSuggestionListComponent = (!this.state.outSideClick && zipcodeSuggestionList) ?
            <div ref={this.setWrapperRef} className="zipcode-suggestion-list">
                {Object.keys(zipcodeSuggestionList).map((key) => {
                    return (
                        <div className="suggestion-list-item" key={zipcodeSuggestionList[key].zip}>
                            <span key={zipcodeSuggestionList[key].zip} onClick={() => this.selectThisZipcode(zipcodeSuggestionList[key])}>
                                {zipcodeSuggestionList[key].zip}
                            </span>
                        </div>
                    )
                })}
            </div> : '';

        return (
            <div className="Zip-Code">
                <div className="Zip-Code-Input"  ref={(r) => { this.zipcodeRef = r }}>
                    <form onSubmit={this.handleSubmit} autocomplete="off">
                    <Input className="Zip-Code-Input-field" label="Enter your Zip Code" width="292px" placeholder="Enter zip code" value={this.props.zipcodeEnteredByUser || ""} name="zipcode-box" onChange={this.getZipcodes} />
                    <span>{zipcodeSuggestionListComponent}</span>
                    {/* {this.props.selectedZipcode && this.props.cityAndState=='' ? <span className="Zip-Code-error">Please Enter valid Zip code</span> : null} */}
                    {this.state.invalidZipCode? <span className="Zip-Code-error">Please Enter valid Zip code</span> : null}
                    </form>
                </div>
            </div>
        );
    }
}

export default Zipcode;